import { FrameComponent } from "../../common/FrameComponent";
import { APP_GIT } from "../../services/api/constants";
import { useServiceUrl } from "../../common/hooks/use-service-url";

interface Props {
  className?: string;
}

export const GitView = ({ className }: Props) => {
  const src = useServiceUrl(APP_GIT);
  return <FrameComponent src={src} />;
};
